// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTent = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M1.266 22l9.579-16.545L9.135 2.5l1.73-1.002L12 3.459l1.135-1.96 1.73 1.002-1.71 2.954L22.736 22zM9.5 20H4.735L12 7.45 19.266 20H14.5L12 15z"
    />
  );
export default SvgIconTent;
